import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import ServiceDetail from './pages/ServiceDetail';
import References from './pages/References';
import Contact from './pages/Contact';
import Forbidden from './pages/Forbidden';
import NotFound from './pages/NotFound';

function App() {
  return (
    <div className="flex min-h-screen flex-col bg-neutral-light-bg text-neutral-dark antialiased">
      {/* Scroll to top on route change */}
      <ScrollToTop />

      {/* Navigation Header */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/om-haveglaede" element={<About />} />
          <Route path="/ydelser/:slug" element={<ServiceDetail />} />
          <Route path="/referencer" element={<References />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
